import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor( public router:Router, public loginService: LoginService) { }

    public userName: "";
    public password: "";
    public currentUser = [];
  ngOnInit(): void {
    this.currentUser = this.loginService.getWorker()
    console.log(this.currentUser)
    // this.currentUser = JSON.st
  }

  submitUser(){
    console.log(this.userName, this.password);

    let sign;
    let a=this.userName
    let b=this.password
    let c=this.currentUser
    c.forEach(
      function(each){
        if(each.userName==a&&each.password==b){
        sign=each
        }
      }
    )
    if (sign){
      let obj = {userName:this.userName, password:this.password,img:sign.picture, Name:sign.Name};
      let c= JSON.stringify(obj)
      localStorage.setItem('loginUser',c);
      this.router.navigate([`/chatpage`]);
    }
    else{
      alert('Check your data')
    }
   

  }
}
